module.exports = "/static/assets/35ca1b46b378e4280df8a864e6b92809.png";